import React, {Component} from "react"

import {H3} from "@irati/ui/src/Headings"
import ghost from "@irati/ui/images/circle_ghost.svg"
import {FormattedMessage} from "@irati/utils/lang"

import PopUpWithImage from "@irati/ui/src/PopUpWithImage"
import NoStock from "./NoStock"

class StockNotificationPopup extends Component {
  render() {
    return (
      <PopUpWithImage
        ref={(c) => { this.popup = c }}
        img={ghost}>
        <H3 base>
          <FormattedMessage id="perks.components.productForms.stockNotificationPopup.text.first" /><br />
          <FormattedMessage id="perks.components.productForms.stockNotificationPopup.text.second" />
        </H3>
        <NoStock />
      </PopUpWithImage>
    )
  }
}

export default StockNotificationPopup
